// Path: ./src/utils/FlyerImageSave.ts
import { adminApiService } from "./api";
import { uploadImageToS3 } from "./image";
import { GfImage } from "@swagger/typescript-fetch-goflyer";

type FlyerImageResponse = {
  alt: string;
  src: string;
  fileName: string;
  srcSmall?: string;
  gfSplitImages: GfImage[];
};

async function handleImage(
  value: File,
  path = `flyers`
): Promise<FlyerImageResponse | null> {
  const responseLarge = await uploadImageToS3(value, false, path);
  if (!responseLarge) {
    return null;
  }
  /**
   * both flyers and product image need to have srcSmall to render in the list
   */
  const resizeSmall = path === "flyers" || path === "productImages";
  /**
   * for flyer, we also split image so that it will load faster in detail page. However, this might change in the future since we will segment each flyer item on the flyer.(like grid)
   */
  console.log("responseLarge", responseLarge);
  const splitLargeImage = path === "flyers";
  const result =
    await adminApiService.gfImageAdminControllerHandleImageProcessing(
      responseLarge?.src,
      undefined,
      resizeSmall,
      splitLargeImage
    );

  return {
    ...responseLarge,
    srcSmall: result?.srcSmall,
    gfSplitImages: result?.gfSplitImages || [],
  };
}

export const saveSplittedFlyerImage = async (
  files: File[],
  path = `flyers`
): Promise<FlyerImageResponse[]> => {
  const results: FlyerImageResponse[] = [];

  for (const file of files) {
    const result = await processImage(file, path);
    result && results.push(result);
  }

  return results;
};

const processImage = (
  file: File,
  path = `flyers`
): Promise<FlyerImageResponse | null> => {
  return new Promise<FlyerImageResponse | null>(async (resolve, _reject) => {
    const response = await handleImage(file, path);
    resolve(response);
  });
};
